import React from "react";
import CrudTable from "../components/CrudTable";

const columns = [
  { key: "name", label: "Document" },
  { key: "type", label: "Type" },
  { key: "related_entity", label: "Linked to" },
  { key: "version", label: "v" },
  { key: "uploader_email", label: "Uploaded by" },
];
const formFields = [
  { name: "name", label: "Document Name", required: true },
  { name: "type", label: "Type", type: "select", default: "agreement",
    options: ["agreement", "invoice", "purchase_order", "asset_image", "warranty_document", "service_report", "insurance", "kyc"].map((s) => ({ value: s, label: s.replace(/_/g, " ") })) },
  { name: "url", label: "Document URL", required: true, wide: true, placeholder: "https://…" },
  { name: "related_entity", label: "Related Entity ID (Brand/Asset/Outlet)" },
  { name: "description", label: "Description", wide: true },
];

export default function Documents() {
  return <CrudTable title="Document Vault"
    description="Centralised storage for agreements, invoices, insurance & compliance documents."
    endpoint="/documents" columns={columns} formFields={formFields} />;
}
